import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Accordion from '../Accordion/Accordion';
// import { ToastContainer } from 'react-toastify';
import './PriceBar.css';
import { roundThis } from '../../../utilities/utils';

// Props
// isSubtotal: boolean

const mapStateToProps = (state) => {
  return {
    languageObj: state.language.sub_components.price_bar_js,
  };
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(class PriceBar extends Component {
  componentWillUnmount() {
    this.props.updateSelectedDiscount(this.props.discountInfo);
  }

  render() {

    const headerRow = (
      <div>
        <div className={'PriceBar-row PriceBar-headerRow'}>
          <div className={'PriceBar-label'}>
            {this.props.isSubtotal ? this.props.languageObj.render.header.is_subtotal_true : this.props.languageObj.render.header.is_subtotal_false}:
          </div>
          <div className={'PriceBar-valueContainer'}>
            <div className={'PriceBar-value'}>
              {this.props.currencySymbol + (this.props.isSubtotal ?
                roundThis(this.props.subtotal).toFixed(2) : roundThis(this.props.total).toFixed(2))}
                {/* (Math.round(this.props.subtotal * 100) / 100).toFixed(2) : (Math.round(this.props.total * 100) / 100).toFixed(2)} */}
            </div>
          </div>
        </div>
        {this.props.discount > 0 && (
          <div className={'PriceBar-row'}>
            <div className={'PriceBar-discount-label'}>
              {this.props.languageObj.render.header.you_saved}
            </div>
            <div className={'PriceBar-discount'}>
              {this.props.currencySymbol + roundThis(this.props.discount).toFixed(2)} !
              {/* (Math.round(this.props.discount * 100) / 100).toFixed(2)} ! */}
            </div>
          </div>
        )}
      </div>
    );

    const priceBarClasses = classNames('PriceBar', {
      'PriceBar--total': true
    });

    return (
      <div className={priceBarClasses}>
        <Accordion
          header={headerRow}
          openInitially={!this.props.isSubtotal}
          closeAfter={2000}
          inverted={true}
        >
          <div className={'PriceBar-lineItemList'}>
            {this.props.lineItemsList.map((lineItems, itemsIndex) => {
              return (
                <div className={'PriceBar-lineItems'} key={itemsIndex}>
                  <div className={'PriceBar-lineItems-time'}>
                    {lineItems.time}
                  </div>
                  {lineItems.lines.map((lineItem, itemIndex) => {
                    const lineItemClasses = classNames('PriceBar-lineItem', {
                      'PriceBar-lineItem--discount': lineItem.isDiscount
                    });
                    if (lineItem.price) {
                      return (
                        <div className={lineItemClasses} key={itemIndex}>
                          <div className={'PriceBar-lineItem-quantity-and-name'}>
                            {lineItem.appliedToCart ? lineItem.name : lineItem.quantity + ' x ' + lineItem.name}
                          </div>
                          <div className={'PriceBar-lineItem-price'}>
                            {lineItem.isDiscount && '-'}{this.props.currencySymbol + roundThis(lineItem.price).toFixed(2)} {lineItem.appliedToCart ? this.props.languageObj.render.accordion.is_discount_true : this.props.languageObj.render.accordion.is_discount_false}
                          </div>
                          <div className={'PriceBar-lineItem-spacer'} />
                        </div>
                      );
                    } else return '';
                  })}
                </div>
              );
            })}
            {this.props.lineItemsList.length === 0 && (
              <div className={'PriceBar-lineItems PriceBar-lineItems--empty'}>
                {this.props.languageObj.render.accordion.line_items_empty}
              </div>
            )}
          </div>
          {this.props.isSubtotal === false && (
            <div className={'PriceBar-priceRows'}>
              {/* <div className={'PriceBar-row'}>
                  <div className={'PriceBar-label'}>
                      {'BASE PRICE'}:
                  </div>
                  <div className={'PriceBar-valueContainer'}>
                      <div className={'PriceBar-value'}>
                          ${(Math.round(this.props.baseprice * 100) / 100).toFixed(2)}
                      </div>
                  </div>
              </div> */}
              {/* {this.props.discount > 0 && (
                  <div className={'PriceBar-row'}>
                      <div className={'PriceBar-discount-label'}>
                          YOU SAVED
                      </div>
                      <div className={'PriceBar-discount'}>
                          ${(Math.round(this.props.discount * 100) / 100).toFixed(2)} !
                      </div>
                  </div>
              )} */}
              <div className={'PriceBar-row'}>
                <div className={'PriceBar-label'}>
                  {this.props.languageObj.render.accordion.subtotal}:
                </div>
                <div className={'PriceBar-valueContainer'}>
                  <div className={'PriceBar-value'}>
                    {this.props.currencySymbol + roundThis(this.props.subtotal).toFixed(2)}
                  </div>
                </div>
              </div>
              {/* <div className={'PriceBar-lineItems'}>
                {this.props.taxes && this.props.taxes.map((taxInfo, index) => {
                  return (
                    <div className={'PriceBar-lineItem'} key={index}>
                      <div className={'PriceBar-lineItem-quantity-and-name'}>
                        {this.props.provinceState} {taxInfo.type} {taxInfo.rate}%:
                      </div>
                      <div className={'PriceBar-lineItem-price'}>
                        ${(taxInfo.total).toFixed(2)}
                      </div>
                      <div className={'PriceBar-lineItem-spacer'} />
                    </div>
                  );
                })}
              </div> */}
              {this.props.taxes && this.props.taxes.map((taxInfo, index) => {
                return (
                  <div className={'PriceBar-row PriceBar-tax'} key={index}>
                    <div className={'PriceBar-label'} style={{ fontSize: '14px' }}>
                      {this.props.provinceState} {taxInfo.type} {taxInfo.rate}%:
                      </div>
                    <div className={'PriceBar-valueContainer'}>
                      <div className={'PriceBar-value'}>
                        {this.props.currencySymbol + roundThis(taxInfo.total).toFixed(2)}
                      </div>
                    </div>
                  </div>
                );
              })}
              {this.props.giftCardsTotal !== 0 && (
                <div className={'PriceBar-row'}>
                  <div className={'PriceBar-label PriceBar-giftcards'}>
                    {this.props.languageObj.render.accordion.gift_cards_total}
                  </div>
                  <div className={'PriceBar-valueContainer'}>
                    <div className={'PriceBar-value'}>
                      {this.props.currencySymbol + roundThis(this.props.giftCardsTotal).toFixed(2)}
                    </div>
                  </div>
                </div>
              )}
              {/* <div className={'PriceBar-row'}>
                <div className={'PriceBar-label'}>
                  {'TAX'}:
                </div>
                <div className={'PriceBar-valueContainer'}>
                  <div className={'PriceBar-value'}>
                    ${(Math.round(this.props.tax * 100) / 100).toFixed(2)}
                  </div>
                </div>
              </div> */}
            </div>
          )}
        </Accordion>
      </div>
    );
  }
})
